(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["docket-barred-box"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('docket-barred')) {
    // the tile map: NPR's square-bin layout, eleven columns, and the territories in a row below
    const TILES = [
      [0, 0, 'AK', 'Alaska'], [0, 10, 'ME', 'Maine'], [1, 9, 'VT', 'Vermont'], [1, 10, 'NH', 'New Hampshire'],
      [2, 0, 'WA', 'Washington'], [2, 1, 'ID', 'Idaho'], [2, 2, 'MT', 'Montana'], [2, 3, 'ND', 'North Dakota'],
      [2, 4, 'MN', 'Minnesota'], [2, 5, 'IL', 'Illinois'], [2, 6, 'WI', 'Wisconsin'], [2, 7, 'MI', 'Michigan'],
      [2, 8, 'NY', 'New York'], [2, 9, 'RI', 'Rhode Island'], [2, 10, 'MA', 'Massachusetts'],
      [3, 0, 'OR', 'Oregon'], [3, 1, 'NV', 'Nevada'], [3, 2, 'WY', 'Wyoming'], [3, 3, 'SD', 'South Dakota'],
      [3, 4, 'IA', 'Iowa'], [3, 5, 'IN', 'Indiana'], [3, 6, 'OH', 'Ohio'], [3, 7, 'PA', 'Pennsylvania'],
      [3, 8, 'NJ', 'New Jersey'], [3, 9, 'CT', 'Connecticut'],
      [4, 0, 'CA', 'California'], [4, 1, 'UT', 'Utah'], [4, 2, 'CO', 'Colorado'], [4, 3, 'NE', 'Nebraska'],
      [4, 4, 'MO', 'Missouri'], [4, 5, 'KY', 'Kentucky'], [4, 6, 'WV', 'West Virginia'], [4, 7, 'VA', 'Virginia'],
      [4, 8, 'MD', 'Maryland'], [4, 9, 'DE', 'Delaware'],
      [5, 1, 'AZ', 'Arizona'], [5, 2, 'NM', 'New Mexico'], [5, 3, 'KS', 'Kansas'], [5, 4, 'AR', 'Arkansas'],
      [5, 5, 'TN', 'Tennessee'], [5, 6, 'NC', 'North Carolina'], [5, 7, 'SC', 'South Carolina'], [5, 8, 'DC', 'District of Columbia'],
      [6, 3, 'OK', 'Oklahoma'], [6, 4, 'LA', 'Louisiana'], [6, 5, 'MS', 'Mississippi'], [6, 6, 'AL', 'Alabama'], [6, 7, 'GA', 'Georgia'],
      [7, 0, 'HI', 'Hawaii'], [7, 3, 'TX', 'Texas'], [7, 8, 'FL', 'Florida'],
    ];
    const TERR = [['PR', 'Puerto Rico'], ['VI', 'Virgin Islands'], ['GU', 'Guam'], ['MP', 'Northern Mariana Islands'], ['AS', 'American Samoa']];

    customElements.define(
      'docket-barred',
      class extends HTMLElement {
        connectedCallback() {
          try {
            this.records = JSON.parse(this.querySelector('[data-records]').textContent);
            this.turn = JSON.parse(this.querySelector('[data-turn]').textContent).filter((h) => this.records[h]);
          } catch (e) {
            return;
          }
          this.byState = {};
          Object.keys(this.records).forEach((h) => { const s = this.records[h].st; if (s) this.byState[s] = h; });
          this.index = 0;
          this.held = 0;
          this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          this.pauseBtn = this.querySelector('[data-pause]');
          this.select = this.querySelector('[data-pick]');

          this.select?.addEventListener('change', () => {
            const h = this.select.selectedOptions[0]?.dataset.handle;
            if (h) { this.show(h); this.setPlaying(false); }
          });
          this.pauseBtn?.addEventListener('click', () => this.setPlaying(this.dataset.playing !== 'true'));
          ['pointerenter', 'focusin'].forEach((ev) => this.addEventListener(ev, () => { this.held += 1; }));
          ['pointerleave', 'focusout'].forEach((ev) => this.addEventListener(ev, () => { this.held = Math.max(0, this.held - 1); }));
          this.querySelectorAll('[data-view-btn]').forEach((b) => b.addEventListener('click', () => this.view(b.dataset.viewBtn)));
          this.buildMap();

          if (this.reduced || this.turn.length < 2) this.setPlaying(false);
          if (this.turn.length < 2 && this.pauseBtn) this.pauseBtn.hidden = true;
          const ms = Math.max(3, Number(this.dataset.seconds) || 4) * 1000;
          this.timer = setInterval(() => {
            if (this.dataset.playing === 'true' && this.held === 0 && !document.hidden && this.turn.length > 1) {
              this.index = (this.index + 1) % this.turn.length;
              this.show(this.turn[this.index]);
            }
          }, ms);
          if (this.turn[1]) this.preload(this.turn[1]);
        }
        disconnectedCallback() { clearInterval(this.timer); }
        setPlaying(on) {
          this.dataset.playing = String(on);
          this.pauseBtn?.setAttribute('aria-pressed', String(!on));
          this.pauseBtn?.setAttribute('aria-label', on ? 'Pause the hats' : 'Play the hats');
        }
        preload(h) {
          const r = this.records[h];
          [r?.w, r?.f].forEach((u) => { if (u) { const i = new Image(); i.src = u; } });
        }
        show(h) {
          const r = this.records[h];
          if (!r) return;
          const $ = (s) => this.querySelector(s);
          const worn = $('[data-worn-link] img');
          if (worn) {
            worn.removeAttribute('srcset');
            worn.src = r.w || r.f;
            worn.classList.toggle('is-flat', !r.w);
          }
          const flat = $('[data-card-link] img');
          if (flat) { flat.removeAttribute('srcset'); flat.src = r.f; }
          [$('[data-worn-link]'), $('[data-card-link]'), $('[data-card-shop]')].forEach((a) => { if (a) a.href = r.u; });
          if ($('[data-worn-tag]')) $('[data-worn-tag]').textContent = r.n;
          if ($('[data-card-name]')) $('[data-card-name]').textContent = r.n;
          if ($('[data-card-object]')) $('[data-card-object]').textContent = r.o;
          if ($('[data-card-sub]')) $('[data-card-sub]').textContent = r.b ? ' · ' + r.b : (r.s ? ' · ' + r.s : '');
          if ($('[data-card-price]')) $('[data-card-price]').textContent = r.p;
          const sw = $('[data-card-colours]');
          if (sw) {
            sw.replaceChildren(...(r.c || []).map((c) => {
              const el = document.createElement('span');
              if (c.b) {
                el.className = 'docket-bbox__sw';
                el.style.background = c.b;
                el.title = c.n;
                el.setAttribute('role', 'img');
                el.setAttribute('aria-label', c.n);
              } else {
                el.className = 'docket-bbox__swname';
                el.textContent = c.n;
              }
              return el;
            }));
          }
          if ($('[data-card-colours-row]')) $('[data-card-colours-row]').hidden = !(r.c && r.c.length);
          const i = this.turn.indexOf(h);
          if (i >= 0) { this.index = i; if (this.turn[i + 1]) this.preload(this.turn[i + 1]); }
        }
        view(which) {
          this.dataset.view = which;
          this.querySelectorAll('[data-view-btn]').forEach((b) => b.setAttribute('aria-pressed', String(b.dataset.viewBtn === which)));
          this.querySelectorAll('[data-pane]').forEach((p) => { p.hidden = p.dataset.pane !== which; });
        }
        buildMap() {
          const map = this.querySelector('[data-map]');
          if (!map) return;
          const make = (abbr, name, row, col) => {
            const h = this.byState[name];
            const el = document.createElement(h ? 'a' : 'span');
            el.className = 'docket-bbox__tile' + (h ? ' has' : '');
            el.textContent = abbr;
            el.title = name;
            if (row !== undefined) { el.style.gridRow = String(row + 1); el.style.gridColumn = String(col + 1); }
            if (h) {
              el.href = this.records[h].u;
              el.setAttribute('aria-label', 'Barred in ' + name);
              const preview = () => { this.show(h); this.setPlaying(false); };
              el.addEventListener('pointerenter', preview);
              el.addEventListener('focus', preview);
            } else {
              el.setAttribute('aria-hidden', 'true');
            }
            return el;
          };
          const grid = document.createElement('div');
          grid.className = 'docket-bbox__grid';
          TILES.forEach(([r, c, a, n]) => grid.appendChild(make(a, n, r, c)));
          const terr = document.createElement('div');
          terr.className = 'docket-bbox__terr';
          TERR.forEach(([a, n]) => { if (this.byState[n] || a !== 'AS') terr.appendChild(make(a, n)); });
          map.append(grid, terr);
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["docket-barred-page"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('docket-barred-page')) {
    customElements.define(
      'docket-barred-page',
      class extends HTMLElement {
        connectedCallback() {
          try {
            this.data = JSON.parse(this.querySelector('[data-bp-data]').textContent);
            this.words = JSON.parse(this.querySelector('[data-bp-words]').textContent);
          } catch (e) {
            return; // the links still work: every tile, row and card is a plain link to its cap
          }
          this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
          this.mouse = window.matchMedia('(hover: hover) and (pointer: fine)');
          this.stage = this.querySelector('[data-bp-stage]');
          this.map = this.querySelector('[data-bp-map]');
          this.tiles = [...this.querySelectorAll('[data-bp-tile]')];
          this.card = this.querySelector('[data-bp-card]');
          this.pinned = null;
          this.pickers();
          this.falls();
          this.mapWire();
          this.chips();
          this.filter();
          this.fromHash();
        }

        // the hero's picker opens the chosen cap
        pickers() {
          this.querySelectorAll('[data-bp-pick]').forEach((form) => {
            form.addEventListener('submit', (e) => {
              e.preventDefault();
              const to = form.querySelector('select').value;
              if (to) window.location.href = to;
            });
          });
        }

        // the waterfalls hold under a finger and on the pause button; under reduced motion they never move
        falls() {
          const falls = this.querySelector('[data-bp-falls]');
          const button = this.querySelector('[data-bp-motion]');
          if (!falls || !button) return;
          const set = (paused) => {
            falls.toggleAttribute('data-paused', paused);
            button.setAttribute('aria-pressed', String(paused));
            button.textContent = paused ? this.words.play : this.words.pause;
          };
          if (this.reduced.matches) set(true);
          button.addEventListener('click', () => set(!falls.hasAttribute('data-paused')));
          falls.addEventListener('touchstart', () => falls.setAttribute('data-held', ''), { passive: true });
          falls.addEventListener('touchend', () => falls.removeAttribute('data-held'), { passive: true });
          falls.addEventListener('touchcancel', () => falls.removeAttribute('data-held'), { passive: true });
        }

        mapWire() {
          if (!this.tiles.length || !this.card) return;
          // one tab stop for the whole map: the arrow keys move between tiles by where they stand
          this.tiles.forEach((t, n) => t.setAttribute('tabindex', n === 0 ? '0' : '-1'));
          this.tiles.forEach((t) => {
            t.addEventListener('click', (e) => {
              if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
              e.preventDefault();
              if (this.pinned === t.dataset.bpTile) {
                window.location.href = this.querySelector('[data-bp-cta]').href;
                return;
              }
              this.pin(t.dataset.bpTile);
            });
            t.addEventListener('pointerenter', (e) => {
              if (e.pointerType === 'mouse' && !this.pinned) this.show(t.dataset.bpTile);
            });
            t.addEventListener('focus', () => {
              this.rove(t);
              if (!this.pinned) this.show(t.dataset.bpTile);
            });
            t.addEventListener('keydown', (e) => this.arrow(e, t));
          });
          this.stage.addEventListener('pointerleave', (e) => {
            if (e.pointerType === 'mouse' && !this.pinned) this.show(null);
          });
          this.querySelector('[data-bp-close]')?.addEventListener('click', () => {
            const was = this.pinned;
            this.pin(null);
            this.tiles.find((t) => t.dataset.bpTile === was)?.focus({ preventScroll: true });
          });
          this.addEventListener('keydown', (e) => {
            if (e.key === 'Escape' && this.pinned) this.pin(null);
          });
        }

        rove(t) {
          this.tiles.forEach((x) => x.setAttribute('tabindex', x === t ? '0' : '-1'));
        }

        arrow(e, t) {
          const dirs = { ArrowLeft: [-1, 0], ArrowRight: [1, 0], ArrowUp: [0, -1], ArrowDown: [0, 1] };
          const d = dirs[e.key];
          if (!d) return;
          e.preventDefault();
          const a = t.getBoundingClientRect();
          const ax = a.left + a.width / 2;
          const ay = a.top + a.height / 2;
          let best = null;
          let score = Infinity;
          this.tiles.forEach((x) => {
            if (x === t) return;
            const b = x.getBoundingClientRect();
            const dx = b.left + b.width / 2 - ax;
            const dy = b.top + b.height / 2 - ay;
            const along = dx * d[0] + dy * d[1];
            if (along <= 1) return;
            const across = Math.abs(dx * d[1] + dy * d[0]);
            const s = along + across * 2.5;
            if (s < score) {
              score = s;
              best = x;
            }
          });
          best?.focus();
        }

        pin(ab) {
          this.pinned = ab && this.data[ab] ? ab : null;
          this.tiles.forEach((x) => x.setAttribute('aria-current', String(x.dataset.bpTile === this.pinned)));
          this.show(this.pinned);
          const url = new URL(window.location.href);
          url.hash = this.pinned ? this.pinned.toLowerCase() : '';
          history.replaceState(history.state, '', this.pinned ? url.href : url.pathname + url.search);
        }

        show(ab) {
          const d = ab && this.data[ab];
          this.card.dataset.state = d ? 'full' : 'empty';
          if (!d) return;
          this.card.dataset.ab = ab;
          this.$('[data-bp-kicker]').textContent = d.c ? `${d.k} · ${d.c}` : d.k;
          this.$('[data-bp-title]').textContent = d.t;
          this.$('[data-bp-price]').textContent = d.pr;
          this.$('[data-bp-cta]').textContent = this.words.cta.replace('[name]', d.s);
          const court = this.$('[data-bp-court]');
          court.hidden = !d.cu;
          if (d.cu) {
            court.href = d.cu;
            court.textContent = this.words.court.replace('[court]', d.c);
          }
          const sw = this.$('[data-bp-swatches]');
          sw.replaceChildren(
            ...d.v.map((v, n) => {
              const b = document.createElement('button');
              b.type = 'button';
              b.className = 'docket-bp__swatch';
              b.style.setProperty('--sw', v.h || '#ccc');
              b.title = v.o;
              b.setAttribute('aria-label', v.o);
              b.addEventListener('click', () => this.colour(d, n));
              b.addEventListener('pointerenter', (e) => {
                if (e.pointerType === 'mouse') this.picture(d.v[n]);
              });
              b.addEventListener('pointerleave', (e) => {
                if (e.pointerType === 'mouse') this.picture(d.v[this.chosen]);
              });
              return b;
            }),
            Object.assign(document.createElement('span'), { className: 'docket-bp__swatch-name' })
          );
          this.colour(d, d.d);
        }

        colour(d, n) {
          this.chosen = n;
          const v = d.v[n];
          this.$$('[data-bp-swatches] button').forEach((b, k) => b.setAttribute('aria-pressed', String(k === n)));
          this.$('.docket-bp__swatch-name').textContent = v.o;
          const href = `${d.u}?variant=${v.id}`;
          this.$('[data-bp-cta]').href = href;
          this.$('[data-bp-link]').href = href;
          this.picture(v);
          this.$('[data-bp-img]').alt = `${d.t} — ${v.o}`;
        }

        picture(v) {
          const img = this.$('[data-bp-img]');
          if (v && img.getAttribute('src') !== v.i) img.src = v.i;
        }

        // a circuit chip lights its jurisdictions; a second press puts the map back
        chips() {
          const chips = [...this.querySelectorAll('[data-bp-circuit]')];
          const light = (key) => {
            if (key) this.map.closest('[data-bp-stage]').setAttribute('data-circuit', key);
            else this.map.closest('[data-bp-stage]').removeAttribute('data-circuit');
            this.tiles.forEach((t) => t.toggleAttribute('data-lit', !!key && t.dataset.c === key));
          };
          chips.forEach((c) => {
            c.addEventListener('click', () => {
              const on = c.getAttribute('aria-pressed') !== 'true';
              chips.forEach((x) => x.setAttribute('aria-pressed', String(x === c && on)));
              this.lit = on ? c.dataset.bpCircuit : null;
              light(this.lit);
            });
            c.addEventListener('pointerenter', (e) => {
              if (e.pointerType === 'mouse') light(c.dataset.bpCircuit);
            });
            c.addEventListener('pointerleave', (e) => {
              if (e.pointerType === 'mouse') light(this.lit);
            });
          });
        }

        // the table's filter: a name, a postal code, a Bluebook abbreviation or a circuit; Enter opens a lone match
        filter() {
          const form = this.querySelector('[data-bp-filter]');
          if (!form) return;
          const input = form.querySelector('input');
          const rows = [...this.querySelectorAll('[data-bp-row]')];
          const parts = [...this.querySelectorAll('[data-bp-part]')];
          const none = this.querySelector('[data-bp-none]');
          const norm = (s) => s.toLowerCase().replace(/[.]/g, '').replace(/\s+/g, ' ').trim();
          const run = () => {
            const q = norm(input.value);
            // a name or a word of it from the first letter; the postal code or the Bluebook abbreviation whole; a circuit from three letters
            const starts = (hay) => hay.startsWith(q) || hay.split(' ').some((w) => w.startsWith(q));
            rows.forEach((r) => {
              const d = r.dataset;
              const hit = starts(d.n) || d.a === q || d.b === q || (q.length > 2 && !!d.c && starts(d.c));
              r.hidden = !!q && !hit;
            });
            parts.forEach((p) => (p.hidden = !p.querySelector('[data-bp-row]:not([hidden])')));
            none.hidden = rows.some((r) => !r.hidden);
          };
          input.addEventListener('input', run);
          form.addEventListener('submit', (e) => {
            e.preventDefault();
            const shown = rows.filter((r) => !r.hidden);
            if (input.value.trim() && shown.length === 1) window.location.href = shown[0].querySelector('a').href;
          });
        }

        // /pages/barred-in#tx opens with Texas pinned and the map in view
        fromHash() {
          const ab = decodeURIComponent(window.location.hash.slice(1)).toUpperCase();
          if (!ab || !this.data[ab]) return;
          this.pin(ab);
          // after the pictures above it have their height, so the map lands where it will stay
          const go = () => this.stage.closest('section').scrollIntoView({ block: 'start' });
          if (document.readyState === 'complete') requestAnimationFrame(go);
          else window.addEventListener('load', go, { once: true });
        }

        $(sel) {
          return this.card.querySelector(sel);
        }

        $$(sel) {
          return this.card.querySelectorAll(sel);
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["docket-barred"] && !Shopify.designMode) return;
  try {
    
  // DNA2 D615(9), B492: the states layout's "Find your jurisdiction" — Go opens the chosen hat's own page. Without a script
  // the A–Z list beside it is the way in.
  if (!window.docketBarredFind) {
    window.docketBarredFind = true;
    document.addEventListener('submit', (event) => {
      const form = event.target.closest && event.target.closest('[data-barred-find]');
      if (!form) return;
      event.preventDefault();
      const url = form.querySelector('select') && form.querySelector('select').value;
      if (url) window.location.href = url;
    });
  }
  if (!customElements.get('docket-barred')) {
    customElements.define(
      'docket-barred',
      class extends HTMLElement {
        connectedCallback() {
          const pick = this.querySelector('[data-pick-select]');
          const row = this.querySelector('[data-row]');
          const tables = Array.from(this.querySelectorAll('.docket-barred__table'));
          const groups = Array.from(this.querySelectorAll('.docket-barred__group'));
          const pause = this.querySelector('[data-pause]');
          const show = () => {
            const v = pick ? pick.value : 'all';
            if (this.dataset.layout === 'grid') {   // DNA2 D530(6), B481: the page's grid shows the circuit picked
              groups.forEach((g) => {
                g.hidden = v !== 'all' && g.dataset.circuit !== v;
              });
              return;
            }
            // DNA2 D532(5), D572(3): a circuit picked shows its static table in the static row's place; every circuit, the
            // row. The hat carousel beside the pickers stays.
            tables.forEach((t) => {
              t.hidden = t.dataset.circuit !== v;
            });
            if (row) row.hidden = v !== 'all';
          };
          pick?.addEventListener('change', show);
          if (pick && pick.value !== 'all') show();   // a value the browser put back is shown, never kept
          pause?.addEventListener('click', () => {
            const stop = this.dataset.motion !== 'paused';
            this.dataset.motion = stop ? 'paused' : 'running';
            pause.textContent = stop ? 'Play motion' : 'Pause motion';
          });
        }
      }
    );
  }

  /* DNA2 D572(3): <docket-hat-show> — one hat at a time, sliding left every data-seconds (4). A scroll-snap track, as the
     hero carousel's (sections/docket-carousel), so a phone swipes it natively. DNA2 D609 (the site review's "duplicated
     California hat"): the track holds each hat once — no copy of the first at the end, which a swipe, a screen reader or
     the page's text showed as California twice; the wrap from the last hat to the first (and back) is a quick fade, not a
     slide. It moves by
     itself only while nothing holds it: a mouse over it, focus in it, a touch or an arrow (each holds it one interval), a
     hidden tab, the section's "Pause motion" (data-motion="paused", WCAG 2.2.2), or prefers-reduced-motion, under which
     it never moves by itself and its arrows jump without the slide. */
  if (!customElements.get('docket-hat-show')) {
    customElements.define(
      'docket-hat-show',
      class extends HTMLElement {
        connectedCallback() {
          if (this.ready) return;
          const track = this.querySelector('[data-show-track]');
          if (!track) return;
          this.ready = true;
          const n = track.children.length;
          if (n < 2) return;
          const still = window.matchMedia('(prefers-reduced-motion: reduce)');
          const every = Math.max(Number(this.dataset.seconds) || 4, 2) * 1000;
          let hover = false;
          let holdUntil = 0;
          const at = () => Math.round(track.scrollLeft / Math.max(track.clientWidth, 1));
          // the slow turn (CSS .is-turning, restarted at every move): the showing hat's tile
          const tiles = [...track.children];
          this.style.setProperty('--turn-s', every / 1000 + 's');
          let turning = -1;
          const turn = (i) => {
            const k = ((i % n) + n) % n;
            if (k === turning || still.matches) return;
            const on = [k];
            const was = [turning];
            tiles.forEach((t, j) => {
              if (on.includes(j) || !was.includes(j)) t.classList.remove('is-turning');
            });
            void track.offsetWidth;   // the restart: the class off, a reflow, the class on
            on.forEach((j) => tiles[j].classList.add('is-turning'));
            turning = k;
          };
          const to = (i, smooth) => {
            turn(i);
            track.scrollTo({ left: i * track.clientWidth, behavior: smooth && !still.matches ? 'smooth' : 'auto' });
          };
          turn(0);
          const hold = () => {
            holdUntil = performance.now() + every;
          };
          // the wrap: fade out, jump unseen, fade in (under reduced motion, a plain jump)
          const wrap = (i) => {
            if (still.matches) return to(i, false);
            track.style.transition = 'opacity 0.18s ease';
            track.style.opacity = '0';
            setTimeout(() => {
              to(i, false);
              track.style.opacity = '1';
            }, 180);
          };
          const next = () => {
            const i = at();
            if (i >= n - 1) wrap(0);
            else to(i + 1, true);
          };
          const prev = () => {
            const i = at();
            if (i <= 0) wrap(n - 1);
            else to(i - 1, true);
          };
          this.querySelector('[data-show-next]')?.addEventListener('click', () => {
            hold();
            next();
          });
          this.querySelector('[data-show-prev]')?.addEventListener('click', () => {
            hold();
            prev();
          });
          this.addEventListener('pointerenter', (e) => {
            if (e.pointerType === 'mouse') hover = true;
            else hold();
          });
          this.addEventListener('pointerleave', (e) => {
            if (e.pointerType === 'mouse') hover = false;
          });
          track.addEventListener('touchstart', hold, { passive: true });
          // a swipe by hand lands without `to`: the hat it lands on turns
          let settle = 0;
          track.addEventListener(
            'scroll',
            () => {
              clearTimeout(settle);
              settle = setTimeout(() => turn(at()), 200);
            },
            { passive: true }
          );
          this.timer = setInterval(() => {
            if (hover || still.matches || document.hidden || performance.now() < holdUntil) return;
            if (this.closest('[data-motion="paused"]') || this.matches(':focus-within')) return;
            if (track.clientWidth === 0) return;   // not shown
            next();
          }, every);
        }

        disconnectedCallback() {
          clearInterval(this.timer);
          this.ready = false;
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["docket-carousel"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('docket-carousel')) {
    customElements.define(
      'docket-carousel',
      class extends HTMLElement {
        connectedCallback() {
          const track = this.querySelector('.docket-carousel__track');
          if (!track) return;
          const slides = Array.from(track.children);
          const dots = Array.from(this.querySelectorAll('.docket-carousel__dot'));
          const at = () => Math.round(track.scrollLeft / Math.max(track.clientWidth, 1));
          const go = (i) => {
            const k = (i + slides.length) % slides.length;
            track.scrollTo({ left: k * track.clientWidth, behavior: 'smooth' });
          };
          const sync = () => {
            const c = at();
            dots.forEach((d, i) => d.setAttribute('aria-current', i === c ? 'true' : 'false'));
          };
          const pause = this.querySelector('[data-pause]');
          pause?.addEventListener('click', () => {
            const stop = this.dataset.motion !== 'paused';
            this.dataset.motion = stop ? 'paused' : 'running';
            pause.textContent = stop ? 'Play motion' : 'Pause motion';
          });
          // D416(2): a slide every N seconds, held only while a slide's button is under a pointer or holds focus
          const every = Number(this.dataset.autoplay || 0) * 1000;
          const still = window.matchMedia('(prefers-reduced-motion: reduce)');
          let held = false;
          this.querySelectorAll('.docket-slide__button').forEach((b) => {
            b.addEventListener('pointerenter', () => { held = true; });
            b.addEventListener('pointerleave', () => { held = false; });
            b.addEventListener('focus', () => { held = true; });
            b.addEventListener('blur', () => { held = false; });
          });
          if (every > 0 && slides.length > 1) {
            setInterval(() => {
              if (held || still.matches || document.hidden || this.dataset.motion === 'paused') return;
              go(at() + 1);
            }, every);
          }
          this.querySelector('[data-prev]')?.addEventListener('click', () => go(at() - 1));
          this.querySelector('[data-next]')?.addEventListener('click', () => go(at() + 1));
          dots.forEach((d, i) => d.addEventListener('click', () => go(i)));
          track.addEventListener('keydown', (e) => {
            if (e.key === 'ArrowRight') { e.preventDefault(); go(at() + 1); }
            if (e.key === 'ArrowLeft') { e.preventDefault(); go(at() - 1); }
          });
          let frame;
          track.addEventListener('scroll', () => { cancelAnimationFrame(frame); frame = requestAnimationFrame(sync); }, { passive: true });
          sync();
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["docket-hero-cards"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('docket-hero-cards')) {
    customElements.define(
      'docket-hero-cards',
      class extends HTMLElement {
        connectedCallback() {
          this.track = this.querySelector('[data-track]');
          this.slides = [...this.querySelectorAll('[data-slide]')];
          this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
          // the moving rows stop while a finger is on them (hover covers the mouse, in CSS)
          this.querySelectorAll('[data-rows]').forEach((rows) => {
            rows.addEventListener('touchstart', () => { rows.dataset.held = 'true'; }, { passive: true });
            rows.addEventListener('touchend', () => { delete rows.dataset.held; }, { passive: true });
            rows.addEventListener('touchcancel', () => { delete rows.dataset.held; }, { passive: true });
          });
          // a picker opens the chosen link
          this.querySelectorAll('[data-picker]').forEach((form) => {
            form.addEventListener('submit', (e) => {
              e.preventDefault();
              const to = form.querySelector('select')?.value;
              if (to) window.location.href = to;
            });
          });
          if (this.slides.length < 2) return;
          this.index = 0;
          this.held = 0;
          const hold = () => { this.held += 1; };
          const release = () => { this.held = Math.max(0, this.held - 1); };
          this.addEventListener('pointerenter', hold);
          this.addEventListener('pointerleave', release);
          this.addEventListener('focusin', hold);
          this.addEventListener('focusout', release);
          this.addEventListener('touchstart', hold, { passive: true });
          this.addEventListener('touchend', release, { passive: true });
          this.querySelector('[data-prev]')?.addEventListener('click', () => this.go(this.index - 1));
          this.querySelector('[data-next]')?.addEventListener('click', () => this.go(this.index + 1));
          const pause = this.querySelector('[data-pause]');
          pause?.addEventListener('click', () => {
            const playing = this.dataset.playing !== 'true';
            this.dataset.playing = String(playing);
            pause.setAttribute('aria-pressed', String(!playing));
            pause.setAttribute('aria-label', playing ? 'Pause the slides' : 'Play the slides');
          });
          if (this.reduced.matches) {
            this.dataset.playing = 'false';
            pause?.setAttribute('aria-pressed', 'true');
            pause?.setAttribute('aria-label', 'Play the slides');
          }
          this.track.addEventListener('scroll', () => {
            const w = this.track.clientWidth || 1;
            this.index = Math.round(this.track.scrollLeft / w);
          }, { passive: true });
          const ms = Math.max(3, Number(this.dataset.seconds) || 6) * 1000;
          this.timer = setInterval(() => {
            if (this.dataset.playing === 'true' && this.held === 0 && !document.hidden) this.go(this.index + 1);
          }, ms);
        }
        disconnectedCallback() { clearInterval(this.timer); }
        go(n) {
          const count = this.slides.length;
          this.index = ((n % count) + count) % count;
          this.track.scrollTo({ left: this.index * this.track.clientWidth, behavior: this.reduced.matches ? 'auto' : 'smooth' });
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["docket-hero-split"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('docket-hero2')) {
    customElements.define(
      'docket-hero2',
      class extends HTMLElement {
        connectedCallback() {
          this.track = this.querySelector('[data-track]');
          this.slides = [...this.querySelectorAll('[data-slide]')];
          if (this.slides.length < 2) return;
          this.index = 0;
          this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
          this.held = 0;
          const hold = () => { this.held += 1; };
          const release = () => { this.held = Math.max(0, this.held - 1); };
          this.addEventListener('pointerenter', hold);
          this.addEventListener('pointerleave', release);
          this.addEventListener('focusin', hold);
          this.addEventListener('focusout', release);
          this.querySelector('[data-prev]')?.addEventListener('click', () => this.go(this.index - 1));
          this.querySelector('[data-next]')?.addEventListener('click', () => this.go(this.index + 1));
          const pause = this.querySelector('[data-pause]');
          pause?.addEventListener('click', () => {
            const playing = this.dataset.playing !== 'true';
            this.dataset.playing = String(playing);
            pause.setAttribute('aria-pressed', String(!playing));
            pause.setAttribute('aria-label', playing ? 'Pause the slides' : 'Play the slides');
          });
          if (this.reduced.matches) {
            this.dataset.playing = 'false';
            pause?.setAttribute('aria-pressed', 'true');
            pause?.setAttribute('aria-label', 'Play the slides');
          }
          this.track.addEventListener('scroll', () => {
            const w = this.track.clientWidth || 1;
            this.index = Math.round(this.track.scrollLeft / w);
          }, { passive: true });
          const ms = Math.max(3, Number(this.dataset.seconds) || 5) * 1000;
          this.timer = setInterval(() => {
            if (this.dataset.playing === 'true' && this.held === 0 && !document.hidden) this.go(this.index + 1);
          }, ms);
        }
        disconnectedCallback() { clearInterval(this.timer); }
        go(n) {
          const count = this.slides.length;
          this.index = ((n % count) + count) % count;
          this.track.scrollTo({ left: this.index * this.track.clientWidth, behavior: this.reduced.matches ? 'auto' : 'smooth' });
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["docket-line"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('docket-line')) {
    customElements.define(
      'docket-line',
      class extends HTMLElement {
        connectedCallback() {
          const b = this.querySelector('[data-pause]');
          b?.addEventListener('click', () => {
            const stop = this.dataset.motion !== 'paused';
            this.dataset.motion = stop ? 'paused' : 'running';
            b.textContent = stop ? 'Play motion' : 'Pause motion';
          });
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
